// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { PlanItemStatusSchema } from '../inputTypeSchemas/PlanItemStatusSchema'

/////////////////////////////////////////
// PLAN ITEM SCHEMA
/////////////////////////////////////////

export const PlanItemSchema = z.object({
  status: PlanItemStatusSchema,
  id: z.string(),
  description: z.string(),
})

export type PlanItem = z.infer<typeof PlanItemSchema>

export default PlanItemSchema;
